import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=6fc8fc40&scoped=true"
import script from "./PositionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionForm.vue?vue&type=style&index=0&id=6fc8fc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8fc40",
  null
  
)

export default component.exports